const e = {
  name: "ArrowUp1",
  dimensions: { width: 25, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 25.4 40" style="enable-background:new 0 0 25.4 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25.4,12.7L12.7,0L0,12.7l1.4,1.4L11.7,3.8V40h2V3.8L24,14.1L25.4,12.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as ArrowUp1
};
